import { Component } from 'opus-angular-seed-core';
@Component({
    template: `
        <div class="mobileheader"></div>
        <div class="header">
            <div class="row1"></div>
        </div>
        <div class="col00">
            <div class="colholder center-col equalize">
                <div class="col col01">
                    <h3>{{ 'general.Page not found' | translate }}</h3><br />
                    <p>{{ 'general.Page not found message ET' | translate }}</p>
                    <p>{{ 'general.Page not found message EN' | translate }}</p>
                </div>
            </div>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/root/index.js